export default "__VITE_ASSET__DrMUnM5y__"